import {useEffect} from 'react';
import {useEditBenefactorPhoneForm} from '../../model';
import {ActionModal, FormInput, useErrorHandler, ErrorModal} from '../../../../shared';
import {useParams} from 'react-router';
import {BenefactorModel} from '../../../../entities';

interface EditBenefactorPhoneModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  benefactor?: BenefactorModel;
}

export const EditBenefactorPhoneModal = ({open, setOpen, benefactor}: EditBenefactorPhoneModalProps) => {
  const params = useParams();

  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditBenefactorPhoneForm({setOpen, benefactorId: params.id ?? '', benefactor: benefactor});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Телефон пользователя',
    title: 'Ошибка при обновлении телефона',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Изменить'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Телефон"
          placeholder="Телефон"
          name="phoneNumber"
          value={values.phoneNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.phoneNumber && errors.phoneNumber}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
